import { SwipeableDrawer, withStyles, WithStyles } from '@material-ui/core';
// import { PaperProps } from '@material-ui/core/Paper';
import * as React from 'react';

const styles = {
	paper: {
		backgroundColor: 'transparent',
		height: '500px',
		marginBottom: '50px',
		paddingRight: '20px',
		width: '100vw'
	},
	root: {
		height: '500px'
	}
}

interface IProps {
	content?: React.ReactNode;
	open: boolean;
	onOpen: () => void;
	onClose: () => void;
}


export type Props = IProps & WithStyles & WithStyles<keyof typeof styles>;

export class ContextDrawer extends React.Component<Props, {}> {
	public render() {
		const { classes, content, open, onOpen, onClose } = this.props;
		console.log('drawer render');
		console.dir(this.props);
		return (
			<SwipeableDrawer
				anchor={'bottom'}
				onOpen={onOpen}
				onClose={onClose}
				open={open}
				classes={{
					paper: classes.paper
				}}
			>
				{content}
			</SwipeableDrawer>
		);
	}
}

export default withStyles(styles)(ContextDrawer) as any;


// WEBPACK FOOTER //
// ./src/components/ContextDrawer.tsx